module.exports = __webpack_public_path__ + "img/brownish_attached.1b11d2d4.svg";